import React from "react";
import { createFragmentContainer, graphql } from "react-relay";
// import { Link } from "found";
import { useTheme } from "./contexts/ThemeContext";
import { loadStripe } from "@stripe/stripe-js";
import CreateSetupSessionMutation from "./mutations/CreateSetupSessionMutation";
import {
    CURRENCY_CODES,
    SUPPORTED_CURRENCIES,
    stripeUnitPrice,
    getNativePrice,
} from "./data/currency_codes";

const {
    REACT_APP_STRIPE_PUBLIC_KEY,
    REACT_APP_PRICE_ID_MONTHLY,
    REACT_APP_PRICE_ID_YEARLY,
    REACT_APP_PRICE_YEARLY_DOLLARS,
    REACT_APP_PRICE_MONTHLY_DOLLARS,
} = process.env;

const stripePromise = loadStripe(REACT_APP_STRIPE_PUBLIC_KEY);
const monthlyPriceId = REACT_APP_PRICE_ID_MONTHLY;
const yearlyPriceId = REACT_APP_PRICE_ID_YEARLY;

function AccountDetails(props) {
    const theme = useTheme();
    const stripeData = props;
    const { is_premium, currency } = props.user;

    let monthlyPrice = getNativePrice(
        currency,
        REACT_APP_PRICE_MONTHLY_DOLLARS,
        "month"
    );

    let stripeMonthlyPrice = stripeUnitPrice(currency, monthlyPrice);

    const onPaymentLinkClick = async (e) => {
        e.preventDefault();
        const stripe = await stripePromise;
        CreateSetupSessionMutation(
            monthlyPriceId,
            currency,
            stripeMonthlyPrice,
            "month",
            false,
            (sessionId) => {
                console.log(sessionId);
                if (sessionId != null) {
                    const result = stripe.redirectToCheckout({
                        sessionId: sessionId,
                    });
                }
            }
        );
    };

    return (
        <div>
            <a
                target="_top"
                style={props.style}
                // className={`theme-${theme.link}`}
                href={stripeData.stripe_Customer.customer_portal_url}
            >
                <button className="btn-action">
                    {props.title}
                </button>
                
            </a>

            {/* <h3 */}
            {/*     style={props.style} */}
            {/*     // className={`theme-${theme.link}`} */}
            {/*     onClick={onPaymentLinkClick} */}
            {/* > */}
            {/*     {props.title} */}
            {/* </h3> */}
        </div>
    );
}

export default createFragmentContainer(AccountDetails, {
    stripe_Customer: graphql`
        fragment AccountDetails_stripe_Customer on StripeCustomerNode {
            id
            customer_id
            customer_portal_url
        }
    `,
});
